import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import { List } from 'material-ui/List';
import RegistrationHistoryListItem from './RegistrationHistoryListItem';
import HistoryIcon from 'material-ui/svg-icons/action/history';

import RegistrationStore from '../../stores/RegistrationStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import { Card, CardHeader } from "material-ui/Card";

class RegistrationHistoryList extends Component {

    constructor(props) {
        super(props);
        this.loadRegistrations = this.loadRegistrations.bind(this);
    }

    componentWillMount() {
        this.loadRegistrations();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userId !== this.props.userId || prevProps.moduleId !== this.props.moduleId) {
            this.loadRegistrations();
        }
    }

    loadRegistrations() {
        if (this.props.userId && this.props.moduleId) {
            ModuleActions.listRegistrationHistory(this.props.moduleId, this.props.userId);
        }
    }

    render() {
        if (!this.state.history || this.state.history.length === 0) { return null; }
        return (
            <Card className="cent-card" key="moduleSegment">
                <CardHeader
                    title="History"
                    avatar={<HistoryIcon/>}
                />
                <List>
                    {this.state.history.map(({guid, score, dateUpdated}) => <RegistrationHistoryListItem key={guid} score={score} dateUpdated={dateUpdated} />)}
                </List>
            </Card>

        );
    }
}

RegistrationHistoryList.getStores = () => ([RegistrationStore]);
RegistrationHistoryList.calculateState = (prevState, {userId, moduleId}) => ({
    isFetching: RegistrationStore.isFetching(),
    history: RegistrationStore.getHistory({moduleId, userId})
});

RegistrationHistoryList.propTypes = {
    userId: PropTypes.number.isRequired,
    moduleId: PropTypes.number.isRequired,
    registrationId: PropTypes.string,
};

export default Container.create(RegistrationHistoryList, {withProps: true});
